export default "__VITE_ASSET__Bb_2apQo__"